import { DefaultRootState } from "react-redux"
import { TaxDto } from "../../tax/Tax"
import { GroupDto } from "../Group"
import { PricingFeeCalculationDto } from "../PricingFeeCalculation"
import { PricingRowDto } from "../PricingRow"
import { PricingTotalDto } from "../PricingTotals"
import { PricingTableItemsStore } from "../reducers"

function getStore(state): PricingTableItemsStore {
    return state.pricingTableReducer as PricingTableItemsStore
}

export function getPricingTableItem(state: DefaultRootState, id: string, objectId: string): PricingRowDto | undefined {
    return getStore(state).pricingTableItems.get(`${objectId}_${id}`)
}

export function getPricingTableItems(state): PricingRowDto[] {
    const arrayOfItems:PricingRowDto[] = []
    for (const [, v] of getStore(state).pricingTableItems) {
        arrayOfItems.push(v)
    }
    return arrayOfItems
}

export function getMainItems(state) {
    const arrayOfItems:PricingRowDto[] = []
    for (const [, v] of getStore(state).pricingTableItems) {
        if (!v.attributes.groupId && !v.attributes.parentId) {
            arrayOfItems.push(v)
        }
    }
    return arrayOfItems
}

export function getBundleItems(state, bundleId: string): PricingRowDto[] {
    const arrayOfItems:PricingRowDto[] = []
    for (const [, v] of getStore(state).pricingTableItems) {
        if (v.attributes.parentId === bundleId) {
            arrayOfItems.push(v)
        }
    }
    return arrayOfItems
}

export function getPricingTableGroupItemIds(
    state: PricingTableItemsStore,
    groupId: string,
): string[] {
    const ids: Array<string> = []
    getStore(state).pricingTableItems.forEach((value, key) => {
        if (value.attributes.groupId === groupId && !value.attributes.parentId) {
            if (key.split("_").length > 0) {
                ids.push(key.split("_")[1])
            }
        }
    })

    return ids
}


export function getPricingTableItemTax(
    state: PricingTableItemsStore,
    item: PricingRowDto | undefined,
    objectId: string,
): TaxDto | null | undefined {
    const taxes = getStore(state).pricingTableTax.get(objectId)
    if (item && taxes instanceof Map && item.attributes.billingMethod && taxes.get(item.attributes.billingMethod)) {
        return taxes.get(item.attributes.billingMethod)
    }
    return null
}

export function getPricingTableItemFees(state: PricingTableItemsStore, objectId: string): PricingFeeCalculationDto[] | undefined {
    return getStore(state).pricingTableFees.get(objectId)
}

export function getPricingTableGroups(state: PricingTableItemsStore, objectId: string): GroupDto[] | undefined {
    const arrayOfGroups:GroupDto[]=[]
    for (const [k, v] of getStore(state).pricingTableGroups) {
        if (k.includes(objectId)) {
            arrayOfGroups.push(v)
        }
    }
    return arrayOfGroups
}

export function getPricingTableId(state: PricingTableItemsStore, objectId: string): string {
    return objectId ? getStore(state).pricingTableId.get(objectId) ?? "" : ""
}

export function getTableId(state: PricingTableItemsStore): string {
    return getStore(state).pricingTableId.values().next()?.value ?? ""
}

export function isBottomPriceEnabled(state: PricingTableItemsStore): boolean {
    return getStore(state).isBottomPriceEnabled
}

export function getPricingTableTaxByBillingMethod(
    state: PricingTableItemsStore,
    billingMethod: string,
    objectId: string,
): TaxDto | undefined | null {
    const taxes = getStore(state).pricingTableTax.get(objectId)
    if (taxes instanceof Map && billingMethod && taxes.get(billingMethod)) {
        return taxes.get(billingMethod)
    }
    return null
}

export function getPricingTableTotals(state: PricingTableItemsStore, objectId: string): PricingTotalDto[] | undefined {
    return getStore(state).pricingTableTotals.get(objectId)
}

export function getPricingTableGroup(state: PricingTableItemsStore, id: string, objectId: string): GroupDto | undefined {
    return getStore(state).pricingTableGroups.get(`${objectId}_${id}`)
}

export function getPricingTableSelectedItems(state: PricingTableItemsStore, objectId: string): Set<string> | undefined {
    return getStore(state).pricingTableSelectedItems.get(objectId)
}

export const Selector = {
    containsItems: (state: PricingTableItemsStore) => {
        return getStore(state).pricingTableItems.size > 0
    },
    getPricingTableItems: (state: PricingTableItemsStore) => {
        const arrayOfItems:PricingRowDto[] = []
        for (const [, v] of getStore(state).pricingTableItems) {
            arrayOfItems.push(v)
        }
        return arrayOfItems
    },
    getItemsTrackingInventoryWithRequestedMeasure: (state: PricingTableItemsStore) => {
        const arrayOfItems: PricingRowDto[] = []
        for (const [, v] of getStore(state).pricingTableItems) {
            if (
                v.attributes.itemObject.attributes.inventoryTracking &&
                v.attributes.inventoryRequestedMeasure !== "0" &&
                v.attributes.parentId === ""
            ) {
                arrayOfItems.push(v)
            }
        }
        return arrayOfItems
    },
    getReferenceRowIDs: (state: PricingTableItemsStore): string[] => {
        const arrayOfItems: string[] = []
        for (const [, v] of getStore(state).pricingTableItems) {
            arrayOfItems.push(v.attributes.referenceRowId)
        }
        return arrayOfItems
    },

    getItemInventoryTracking(state: PricingTableItemsStore, itemId: string): boolean {
        for (const [, v] of getStore(state).pricingTableItems) {
            if (v.id == itemId) {
                return v.attributes.itemObject.attributes.inventoryTracking
            }
        }
        return false
    },

    getIsWorkflowLoading(state: PricingTableItemsStore): boolean {
        return getStore(state).isWorkflowLoading
    },
}


// WEBPACK FOOTER //
// ./src/state/pricing/selectors/selector.ts